import { POST_CONTACTFORM } from '../actions/types';

const contactforms = (state = {}, action) => {
  switch (action.type) {
    case POST_CONTACTFORM:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default contactforms;